"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFromEnv = void 0;
const zod_1 = require("zod");
const getFromEnv = (name, schema, parseAsJSON = !!schema) => {
    const envValue = process.env[name];
    let envValueParsed = envValue;
    if (parseAsJSON && envValue) {
        try {
            envValueParsed = JSON.parse(envValue);
        }
        catch (e) {
        }
    }
    try {
        return (schema ?? zod_1.z.string()).parse(envValueParsed);
    }
    catch (e) {
        console.log(`failed to parse ${name} env variable, value ${envValue}`);
        throw new Error(`failed to parse ${name} env variable`, { cause: e });
    }
};
exports.getFromEnv = getFromEnv;
//# sourceMappingURL=env.js.map